function dateFormatter(date, that, type) {
  let dayjs = that.$dayjs
  return dayjs(date).format('YYYY-MM-DD') === 'Invalid Date'
    ? '/'
    : dayjs(dayjs.unix(parseInt(date)).$d).format(type ? type : 'YYYY-MM-DD')
  // dayjs(date).format(type ? type : 'YYYY-MM-DD')
}

export { dateFormatter }
